import React, { Component } from "react";
import moment from "moment-timezone";
import Textarea from "react-textarea-autosize";

// Components
import SaveBtn from "../../utils/edit-item/SaveBtn";
import DeleteBtn from "../../utils/edit-item/DeleteBtn";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

// CSS
import "../../../css/forms/edit-item.css";

class TrainingSurveyItemAdmin extends Component {
	render() {
		const { item, updateLoading } = this.props;

		return (
			<div
				className={
					"edit-item edit-item--rows" + (item.successfull ? ` successful-row` : ``)
				}
			>
				<div className="item-row">
					<input
						type="text"
						id="title"
						className="main-field"
						placeholder="Enter title"
						maxLength="255"
						disabled={updateLoading}
						value={item.title}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
					<div className="item-date">
						{moment
							.utc(item.date_added)
							.local()
							.format("lll")}
					</div>
					<div className="btn-wrap">
						<SaveBtn
							shown={!!item.titleChanged}
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.handleSubmit}
						/>
						<DeleteBtn
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.deleteItem}
						/>
					</div>
				</div>
				<div className="item-row">
					<input
						type="url"
						id="url"
						placeholder="Enter survey url"
						maxLength="255"
						disabled={updateLoading}
						value={item.url}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
				</div>
				<div className="item-row">
					<Textarea
						id="description"
						placeholder="Description"
						value={!!item.description ? item.description : ""}
						onChange={this.props.handleDescriptionChange}
					/>
				</div>
			</div>
		);
	}
}

export default TrainingSurveyItemAdmin;



// WEBPACK FOOTER //
// ./src/components/admin/training-surveys/TrainingSurveyItemAdmin.js